// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li {
  list-style: none;
}
ul {
  margin: 0px;
  padding: 0px;
}
.topBox .ant-affix {
  background: #fff;
  z-index: 3000;
  min-width: 1200px;
  height: 70px !important;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
}
.header {
  width: 100%;
  position: absolute;
  z-index: 3000;
}
.header .logo {
  padding-top: 7px;
}
.header .menu {
  flex: 1;
}
.header .menu > ul {
  display: flex;
  justify-content: flex-end;
}
.header .menu > ul > li {
  padding: 0px 20px;
}
.header .menu .link {
  line-height: 70px;
}
.header a {
  color: #333;
}
.header a:hover {
  color: #0052d9;
}
.header .container {
  width: 1200px;
  margin: 0px auto;
  display: flex;
}
.header .product {
  position: relative;
}
.header .product-ul {
  display: none;
  position: absolute;
  width: 200px;
  left: -50px;
  z-index: 3000;
  background: #fff;
  border-radius: 5px;
  text-align: center;
}
.header .product-ul li {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.header .product-ul li a {
  padding: 10px 20px;
  margin: 0px !important;
  line-height: 20px !important;
  font-size: 14px;
  color: #333 !important;
  display: inline-block;
}
.header .product-ul li a:hover {
  color: #0052d9 !important;
}
.header .product:hover .product-ul {
  display: block;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
}
.header .about {
  position: relative;
}
.header .about-ul {
  display: none;
  position: absolute;
  width: 120px;
  left: 0px;
  z-index: 3000;
  background: #fff;
  border-radius: 5px;
  text-align: center;
}
.header .about-ul li {
  width: 100%;
  line-height: 40px;
  border-bottom: 1px solid #eee;
}
.header .about-ul li a {
  padding: 0px;
  margin: 0px;
  line-height: 40px !important;
  font-size: 14px;
  color: #333 !important;
}
.header .about-ul li a:hover {
  color: #0052d9 !important;
}
.header .about:hover .about-ul {
  display: block;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/index.less"],"names":[],"mappings":"AAAA;EAAG,gBAAA;AAEH;AADA;EAAG,WAAA;EAAa,YAAA;AAKhB;AAJA;EAAmB,gBAAA;EAAiB,aAAA;EAAc,iBAAA;EAAmB,uBAAA;EAAyB,+CAAA;AAW9F;AAVA;EAAQ,WAAA;EAAY,kBAAA;EAAoB,aAAA;AAexC;AAfA;EACU,gBAAA;AAiBV;AAlBA;EAEU,OAAA;AAmBV;AArBA;EAGY,aAAA;EAAe,yBAAA;AAsB3B;AAzBA;EAIgB,iBAAA;AAwBhB;AA5BA;EAMc,iBAAA;AAyBd;AA/BA;EAQM,WAAA;AA0BN;AAlCA;EASY,cAAA;AA4BZ;AArCA;EAUe,aAAA;EAAc,gBAAA;EAAiB,aAAA;AAgC9C;AA1CA;EAYa,kBAAA;AAiCb;AA7CA;EAagB,aAAA;EAAc,kBAAA;EAAoB,YAAA;EAAa,WAAA;EAAY,aAAA;EAAc,gBAAA;EAAiB,kBAAA;EAAmB,kBAAA;AA0C7H;AAvDA;EAcW,WAAA;EAAY,6BAAA;AA6CvB;AA3DA;EAea,kBAAA;EAAmB,sBAAA;EAAuB,4BAAA;EAA6B,eAAA;EAAgB,sBAAA;EAAuB,qBAAA;AAoD3H;AAnEA;EAgBmB,yBAAA;AAsDnB;AAtEA;EAkB4B,cAAA;EAAiB,+CAAA;AAwD7C;AA1EA;EAoBW,kBAAA;AAyDX;AA7EA;EAqBW,aAAA;EAAc,kBAAA;EAAoB,YAAA;EAAa,SAAA;EAAU,aAAA;EAAc,gBAAA;EAAiB,kBAAA;EAAmB,kBAAA;AAkEtH;AAvFA;EAsBc,WAAA;EAAY,iBAAA;EAAkB,6BAAA;AAsE5C;AA5FA;EAuBgB,YAAA;EAAa,WAAA;EAAY,4BAAA;EAA8B,eAAA;EAAgB,sBAAA;AA4EvF;AAnGA;EAwByB,yBAAA;AA8EzB;AAtGA;EAyBwB,cAAA;EAAiB,+CAAA;AAiFzC","sourcesContent":["li{list-style: none;}\nul{margin: 0px; padding:0px;}\n.topBox .ant-affix{background:#fff; z-index:3000; min-width: 1200px; height: 70px !important; box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05);}\t\t\t\t\t\n.header{width:100%; position: absolute; z-index:3000; \n    .logo{padding-top:7px;}\n    .menu{flex:1;\n        >ul{display: flex; justify-content: flex-end;\n            >li{padding:0px 20px;}\n        }\n        .link{line-height:70px;}\n    }\n    a{color:#333;}\n    a:hover{color: #0052d9;}\n    .container{width:1200px; margin:0px auto; display: flex;}\n    \n    .product{position: relative;}\n    .product-ul{display:none; position: absolute; width:200px; left:-50px; z-index:3000; background:#fff; border-radius:5px; text-align: center;\n        li{width:100%; border-bottom: 1px solid #eee;}\n        li a{padding:10px 20px; margin:0px !important; line-height:20px !important; font-size:14px; color:#333 !important; display: inline-block;}\n        li a:hover{color:#0052d9 !important;}\n    }\n\t.product:hover .product-ul{display: block;  box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05);}\n    \n    .about{position: relative;}\n\t.about-ul{display:none; position: absolute; width:120px; left:0px; z-index:3000; background:#fff; border-radius:5px; text-align: center;}\n\t.about-ul li{width:100%; line-height:40px; border-bottom: 1px solid #eee;}\n\t.about-ul li a{padding:0px; margin:0px; line-height: 40px !important; font-size:14px; color:#333 !important;}\n    .about-ul li a:hover{color:#0052d9 !important;}\n\t.about:hover .about-ul{display: block;  box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05);}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
